import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from 'src/redux/reducers';


const buildStore = ({ name, state = {}, middlewares = {} }) => {
  const composeEnhancers = composeWithDevTools({ name });

  const enhancer = composeEnhancers(
    compose(applyMiddleware(thunk.withExtraArgument(middlewares)))
  );

  return createStore(
    reducers,
    state,
    enhancer
  );
};

export default buildStore;
